import { render, staticRenderFns } from "./CustomerWindowView.vue?vue&type=template&id=e212df8e&scoped=true&"
import script from "./CustomerWindowView.vue?vue&type=script&lang=js&"
export * from "./CustomerWindowView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e212df8e",
  null
  
)

export default component.exports